import { useState } from "react";
import RadioButtonGroup from "./RadioButtonGroup";
import RadioButton from "ui/forms/RadioButton";

## Horizontal Layout

export function HorizontalGroup() {
  const [selected, setSelected] = useState("option1");
  return (
    <RadioButtonGroup orientation="horizontal">
      <RadioButton
        name="horizontal"
        id="h-1"
        value="option1"
        label="Option 1"
        checked={selected === "option1"}
        onClick={() => setSelected("option1")}
      />
      <RadioButton
        name="horizontal"
        id="h-2"
        value="option2"
        label="Option 2"
        checked={selected === "option2"}
        onClick={() => setSelected("option2")}
      />
      <RadioButton
        name="horizontal"
        id="h-3"
        value="option3"
        label="Option 3"
        checked={selected === "option3"}
        onClick={() => setSelected("option3")}
      />
    </RadioButtonGroup>
  );
}

<HorizontalGroup />

---

## Vertical Layout

export function VerticalGroup() {
  const [selected, setSelected] = useState("basic");
  const plans = [
    { value: "basic", label: "Basic Plan" },
    { value: "pro", label: "Pro Plan" },
    { value: "enterprise", label: "Enterprise Plan" },
  ];
  return (
    <RadioButtonGroup orientation="vertical">
      {plans.map((plan) => (
        <RadioButton
          key={plan.value}
          name="vertical"
          id={`v-${plan.value}`}
          value={plan.value}
          label={plan.label}
          checked={selected === plan.value}
          onClick={() => setSelected(plan.value)}
        />
      ))}
    </RadioButtonGroup>
  );
}

<VerticalGroup />

---

## Comparison

<div style={{ display: "flex", gap: "3rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Horizontal:**</p>
    <RadioButtonGroup orientation="horizontal">
      <RadioButton name="comp-h" id="comp-h-1" value="a" label="A" checked />
      <RadioButton name="comp-h" id="comp-h-2" value="b" label="B" />
      <RadioButton name="comp-h" id="comp-h-3" value="c" label="C" />
    </RadioButtonGroup>
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Vertical:**</p>
    <RadioButtonGroup orientation="vertical">
      <RadioButton name="comp-v" id="comp-v-1" value="a" label="A" checked />
      <RadioButton name="comp-v" id="comp-v-2" value="b" label="B" />
      <RadioButton name="comp-v" id="comp-v-3" value="c" label="C" />
    </RadioButtonGroup>
  </div>
</div>

---

## Survey Question Example

export function SurveyQuestion() {
  const [answer, setAnswer] = useState("");
  const options = [
    { value: "1", label: "Strongly Disagree" },
    { value: "2", label: "Disagree" },
    { value: "3", label: "Neutral" },
    { value: "4", label: "Agree" },
    { value: "5", label: "Strongly Agree" },
  ];
  return (
    <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "400px" }}>
      <p style={{ marginBottom: "0.75rem", fontWeight: 500 }}>I would recommend this product to a friend.</p>
      <RadioButtonGroup orientation="vertical">
        {options.map((opt) => (
          <RadioButton
            key={opt.value}
            name="survey"
            id={`survey-${opt.value}`}
            value={opt.value}
            label={opt.label}
            checked={answer === opt.value}
            onClick={() => setAnswer(opt.value)}
          />
        ))}
      </RadioButtonGroup>
    </div>
  );
}

<SurveyQuestion />


